import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Landing from "./pages/Landing";
import Installation from "./components/Installation";
import Features from "./components/Features";
import Projects from "./components/Projects";
import Support from "./components/Support";



const App = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/Installation" element={<Installation />} />
          <Route path="/Features" element={<Features />} />
          <Route path="/Projects" element={<Projects />} />
          <Route path="/Support" element={<Support />} />
        </Routes>
      </Router>
    </>
  );
};

export default App;
